// extracted by mini-css-extract-plugin
export default {"Small":"GenderSportIcon-module__Small__uRsBV","Medium":"GenderSportIcon-module__Medium__hf1E7"};